import { render } from "./preLessonInfo.vue?vue&type=template&id=8806447e&scoped=true"
import script from "./preLessonInfo.vue?vue&type=script&lang=js"
export * from "./preLessonInfo.vue?vue&type=script&lang=js"

import "./preLessonInfo.vue?vue&type=style&index=0&id=8806447e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8806447e"]])

export default __exports__